import { CairoTranslationsOrDefault } from './cairoTranslations';

export const translationsImportsMap = {
  ar: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_ar-json" */ '../assets/locale/messages_ar.json'
    ) as Promise<CairoTranslationsOrDefault>,
  bg: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_bg-json" */ '../assets/locale/messages_bg.json'
    ) as Promise<CairoTranslationsOrDefault>,
  ca: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_ca-json" */ '../assets/locale/messages_ca.json'
    ) as Promise<CairoTranslationsOrDefault>,
  cs: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_cs-json" */ '../assets/locale/messages_cs.json'
    ) as Promise<CairoTranslationsOrDefault>,
  da: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_da-json" */ '../assets/locale/messages_da.json'
    ) as Promise<CairoTranslationsOrDefault>,
  de: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_de-json" */ '../assets/locale/messages_de.json'
    ) as Promise<CairoTranslationsOrDefault>,
  el: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_el-json" */ '../assets/locale/messages_el.json'
    ) as Promise<CairoTranslationsOrDefault>,
  en: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_en-json" */ '../assets/locale/messages_en.json'
    ) as Promise<CairoTranslationsOrDefault>,
  es: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_es-json" */ '../assets/locale/messages_es.json'
    ) as Promise<CairoTranslationsOrDefault>,
  fi: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_fi-json" */ '../assets/locale/messages_fi.json'
    ) as Promise<CairoTranslationsOrDefault>,
  fr: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_fr-json" */ '../assets/locale/messages_fr.json'
    ) as Promise<CairoTranslationsOrDefault>,
  he: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_he-json" */ '../assets/locale/messages_he.json'
    ) as Promise<CairoTranslationsOrDefault>,
  hi: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_hi-json" */ '../assets/locale/messages_hi.json'
    ) as Promise<CairoTranslationsOrDefault>,
  hu: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_hu-json" */ '../assets/locale/messages_hu.json'
    ) as Promise<CairoTranslationsOrDefault>,
  id: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_id-json" */ '../assets/locale/messages_id.json'
    ) as Promise<CairoTranslationsOrDefault>,
  it: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_it-json" */ '../assets/locale/messages_it.json'
    ) as Promise<CairoTranslationsOrDefault>,
  ja: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_ja-json" */ '../assets/locale/messages_ja.json'
    ) as Promise<CairoTranslationsOrDefault>,
  ko: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_ko-json" */ '../assets/locale/messages_ko.json'
    ) as Promise<CairoTranslationsOrDefault>,
  lt: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_lt-json" */ '../assets/locale/messages_lt.json'
    ) as Promise<CairoTranslationsOrDefault>,
  ms: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_ms-json" */ '../assets/locale/messages_ms.json'
    ) as Promise<CairoTranslationsOrDefault>,
  nl: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_nl-json" */ '../assets/locale/messages_nl.json'
    ) as Promise<CairoTranslationsOrDefault>,
  no: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_no-json" */ '../assets/locale/messages_no.json'
    ) as Promise<CairoTranslationsOrDefault>,
  pl: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_pl-json" */ '../assets/locale/messages_pl.json'
    ) as Promise<CairoTranslationsOrDefault>,
  pt: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_pt-json" */ '../assets/locale/messages_pt.json'
    ) as Promise<CairoTranslationsOrDefault>,
  ro: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_ro-json" */ '../assets/locale/messages_ro.json'
    ) as Promise<CairoTranslationsOrDefault>,
  ru: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_ru-json" */ '../assets/locale/messages_ru.json'
    ) as Promise<CairoTranslationsOrDefault>,
  sk: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_sk-json" */ '../assets/locale/messages_sk.json'
    ) as Promise<CairoTranslationsOrDefault>,
  sl: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_sl-json" */ '../assets/locale/messages_sl.json'
    ) as Promise<CairoTranslationsOrDefault>,
  sv: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_sv-json" */ '../assets/locale/messages_sv.json'
    ) as Promise<CairoTranslationsOrDefault>,
  th: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_th-json" */ '../assets/locale/messages_th.json'
    ) as Promise<CairoTranslationsOrDefault>,
  tl: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_tl-json" */ '../assets/locale/messages_tl.json'
    ) as Promise<CairoTranslationsOrDefault>,
  tr: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_tr-json" */ '../assets/locale/messages_tr.json'
    ) as Promise<CairoTranslationsOrDefault>,
  uk: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_uk-json" */ '../assets/locale/messages_uk.json'
    ) as Promise<CairoTranslationsOrDefault>,
  vi: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_vi-json" */ '../assets/locale/messages_vi.json'
    ) as Promise<CairoTranslationsOrDefault>,
  zh: () =>
    import(
      /* webpackChunkName: "cairo-locale-messages_zh-json" */ '../assets/locale/messages_zh.json'
    ) as Promise<CairoTranslationsOrDefault>,
};
